import ImagePreview from '@admin/components/image_preview'
import Image from '@admin/components/image'
import Icon from '@admin/components/icon'
import PropTypes from 'prop-types'
import React from 'react'

class ImageAttachment extends React.Component {

  static propTypes = {
    image: PropTypes.object,
    onRemove: PropTypes.func
  }

  _handleRemove = this._handleRemove.bind(this)

  render() {
    const { image } = this.props
    return (
      <div className="maha-composer-image">
        { image.file ?
          <ImagePreview { ...this._getImagePreview() } /> :
          <Image { ...this._getImage() } />
        }
        { !image.id ?
          <div><Icon icon="circle-o-notch fa-spin" /></div> :
          <Icon icon="times" onClick={ this._handleRemove } />
        }
      </div>
    )
  }

  _getImagePreview() {
    const { image } = this.props
    return {
      image: image.file,
      cover: true
    }
  }

  _getImage() {
    const { image } = this.props
    return {
      src: image.path,
      transforms: {
        fit: 'cover',
        w: 100,
        h: 100
      }
    }
  }

  _handleRemove() {
    this.props.onRemove()
  }

}

export default ImageAttachment
